import React, { useState } from "react";
import "./Experience.css";

// Importing images
import cloud from "./images/cloud.svg";
import pirateShip from "./images/pirate-ship.svg";
import waves3 from "./images/waves-3.png";
import waves2 from "./images/waves-2.png";
import waves1 from "./images/waves-1.png";

import DataAn from "./images/dataAn.png"
import ml from "./images/ml.png"
import fe from "./images/frontend.png"
import php from "./images/php.png"
import dj from "./images/django.png"
import ai from "./images/ai.png"

const workExperiences = [
  {
    image: DataAn,
    title: "Quality Assurance",
    subtitle: "Shanghai Jiadao Information Technology",
    description: "Utilized Selenium for automated testing and Excel for tracking and analyzing results effectively.",
  },
  {
    image: ml,
    title: "Backend Developer",
    subtitle: "Edgelink Services LLC",
    description: "Built ML models to predict stock data and developed backend features for better functionality.",
  },
  {
    image: fe,
    title: "Frontend Developer",
    subtitle: "Cradi Investment Holding Group Inc",
    description: "Participated in website development under CradiMedTech, focusing on modern UI/UX design.",
  },
];

const projectExperiences = [
  {
    image: php,
    title: "MedProLink",
    subtitle: "XAMPP with PHP and MySQL",
    description: "Built a doctor appointment system using PHP and MySQL, Familiar SQL language and APIs.",
  },
  {
    image: dj,
    title: "SNMP Project",
    subtitle: "Django & SNMP",
    description: "Developed a web-based SNMP viewer using Django as backend and React for the frontend.",
  },
  {
    image: ai,
    title: "UndetectableGPT.net",
    subtitle: "Python, NLTK, and Gensim",
    description: "Created undetectablegpt.net, integrating advanced text processing with NLTK and Gensim.",
  },
];


const Experience = () => {
  const [activeTab, setActiveTab] = useState("work"); // work or project
  const [selectedIndex, setSelectedIndex] = useState(0); // Index of selected item

  const currentData =
    activeTab === "work" ? workExperiences : projectExperiences;
  return (
    <div className="section num2" id="experience">
      <h1 className="experiencesection-title">Work & Project Experience</h1>
      <div className="experiencecontainer1">
        {/* Tabs */}
        <div className="experience-tabs">
          <button
            className={`experience-tab ${activeTab === "work" ? "active" : ""}`}
            onClick={() => setActiveTab("work")}
          >
            Work
          </button>
          <button
            className={`experience-tab ${
              activeTab === "project" ? "active" : ""
            }`}
            onClick={() => setActiveTab("project")}
          >
            Project
          </button>
        </div>

        <div className="experience-content">
          {/* Vertical Tabs */}
          <div className="experience-vertical-tabs">
            {currentData.map((item, index) => (
              <button
                key={index}
                className={`vertical-tab ${
                  selectedIndex === index ? "selected" : ""
                }`}
                onClick={() => setSelectedIndex(index)}
              >
                {item.title}
              </button>
            ))}
          </div>

          {/* Card */}
          <div className="experience-card">
            <img
              src={currentData[selectedIndex].image}
              alt={currentData[selectedIndex].title}
              className="experience-card-image"
            />
            <h2 className="experience-card-title">
              {currentData[selectedIndex].title}
            </h2>
            <h3 className="experience-card-subtitle">
              {currentData[selectedIndex].subtitle}
            </h3>
            <p className="experience-card-description">
              {currentData[selectedIndex].description}
            </p>
          </div>
        </div>
      </div>

      <div className="experiencehome__container experiencecontainer">
        {/* Clouds */}
        <img src={cloud} alt="Cloud" className="experiencehome__cloud-1" />
        <img src={cloud} alt="Cloud" className="experiencehome__cloud-2" />

        {/* Images and Waves */}
        <div className="experiencehome__images">
          <div
            className="experiencehome__waves-3"
            style={{ backgroundImage: `url(${waves3})` }}
          ></div>
          <div
            className="experiencehome__waves-2"
            style={{ backgroundImage: `url(${waves2})` }}
          ></div>
          <img src={pirateShip} alt="Pirate ship" className="experiencehome__ship" />
          <div
            className="experiencehome__waves-1"
            style={{ backgroundImage: `url(${waves1})` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
